module.exports = __webpack_public_path__ + "static/media/2.73600958.png";